import React from 'react'

const Policies = () => {
  return (
    <div>Policies</div>
  )
}

export default Policies